import { extendTheme } from '@chakra-ui/react';
import { createBreakpoints } from '@chakra-ui/theme-tools';

const breakpoints = createBreakpoints({
  sm: '40em',
  md: '52em',
  lg: '64em',
  xl: '80em',
});

export const theme = extendTheme({
  components: {
    Input: {
      defaultProps: {
        size: 'md',
      },
    },
    Checkbox: {
      defaultProps: {
        size: 'lg',
        rounded: 'xl'
      },
    },
    Button: {
      sizes: {
        lg: {
          px: 10,
          py: 4,
        },
      },
      defaultProps: {
        colorScheme: 'veryLightBlue',
        size: 'lg',
      },
    },
  },
  initialColorMode: 'light',
  useSystemColorMode: false,
  colors: {
    veryLightBlue: {
      50: '#ecf8f8',
      100: '#c7ebe9',
      200: '#a1ddda',
      300: '#7cd0cb',
      400: '#56c3bc',
      500: '#56c3bc',
      600: '#56c3bc',
      700: '#56c3bc',
    },
  },
  breakpoints,
  styles: {
    global: {
      'html, body': {
        fontFamily: `Roboto, Helvetica, Arial, sans-serif`,
      },
    },
  },
});
